import { useState, useEffect, useRef, useMemo } from "react";


import "./Admin.css";
import Heading from "../components/Headingbtn/Heading";
import "../components//Reports/Reports.css";
import { Link, useNavigate } from "react-router-dom";
import { PiNotePencilFill } from "react-icons/pi";
import { TbAlertTriangleFilled } from "react-icons/tb";
import { RiUser3Fill } from "react-icons/ri";
import { FaUserTie, FaBackspace } from "react-icons/fa";
import {
  FaUserXmark,
  FaUserCheck,
  FaUserGear,
  FaUserPen,
  FaUserPlus,
} from "react-icons/fa6";
import { LuNotebookPen } from "react-icons/lu";
import { GoTriangleDown } from "react-icons/go";
// import { LuNotebookPen } from "react-icons/lu";

function Admin() {
  const [error, seterror] = useState({
    confirmpassword: "",
  });

  const [listingValues, setListingValues] = useState({
    vendor_id: "",
    vendor: "",
    state: "",
    year: "",
    month: "",
    division: "",
  });

  const [selectedTable, setSelectedTable] = useState(null);

  const [userupdate, setUserupdate] = useState({
    hr: "",
    username: "",
  });

  const [vendorupdate, setvendorupdate] = useState({
    vendor: "",
    username: "",
  });

  const [active, setactive] = useState({
    user: "",
    vendor: "",
  });
  const [inactive, setinactive] = useState({
    user: "",
    vendor: "",
  });

  const [issubmitted, setissubmitted] = useState(false);
  const [showAdditionalComponent, setShowAdditionalComponent] = useState(false);
  const [VendorsDashboard, setVendorsDashboard] = useState(false);
  const [EmployeeDashboard, setEmployeeDashboard] = useState(false);
  const [reports, setreports] = useState(false);
  // const [isMain3PopupOpen, setIsMain3PopupOpen] = useState(false);
  const [popupvalue, setPopupvalue] = useState("");

  const [vendor, setvendor] = useState([]);
  const [hruser, sethruser] = useState([]);

  const [inactivevendor, setinactivevendor] = useState([]);
  const [inactiveuser, setinactiveuser] = useState([]);

  const [vendordetails, setvendordetails] = useState({
    vendorcode: "",
    vendorname: "",
    username: "",
    password: "",
    confirmpassword: "",
    email: "",
    state: "",
    ph: "",
  });

  // const [showTerms, setShowTerms] = useState(true);

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));
  const menuRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [results, setresults] = useState({
    year: "",
    month: "",
  });
  const [userpassword, setuserpassword] = useState({
    username: "",
    newpassword: "",
    confirmpassword: "",
  });
  const [vendorpassword, setvendorpassword] = useState({
    username: "",
    newpassword: "",
    confirmpassword: "",
  });

  const [subs, setsubs] = useState([]);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = Array.from({ length: 5 }, (_, i) => 2024 + i);

  const handleSubmit = (event) => {
    event.preventDefault();
    setissubmitted(true);
    setShowAdditionalComponent(true);
    setSelectedTable("register");
  };

  // user create
  const handleCreate = async (type) => {
    if (vendordetails.password !== vendordetails.confirmpassword) {
      alert("Password and Confirm Password should be same");
      return;
    }
    if (
      vendordetails.username.trim() &&
      vendordetails.password.trim() &&
      (vendordetails.state || type === "employee" || type === "hr")
    ) {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/createuser.php`;
      const formData = new FormData();

      formData.append("subscriber_id", subs?.subscriber_id);
      formData.append("username", vendordetails.username);
      formData.append("password", vendordetails.password);
      formData.append("email", vendordetails.email);
      formData.append("phone_no", vendordetails.ph);
      formData.append("role", type);

      if (type === "vendor" || type === "client") {
        formData.append("state", vendordetails.state);
        formData.append("code", vendordetails.vendorcode);
        formData.append("name", vendordetails.vendorname);
      } else {
        formData.append("state", "");
        formData.append("code", "");
        formData.append("name", vendordetails.username);
      }

      if (subs?.pack === "demo") {
        formData.append("type", "demo");
      } else {
        formData.append("type", "");
      }

      const response = fetch(apiUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setvendordetails({
            vendorcode: "",
            vendorname: "",
            username: "",
            password: "",
            email: "",
            state: "",
            ph: "",
          });
          setPopupvalue("");
          setVendorsDashboard(false);
          setEmployeeDashboard(false);
          if (company) {
            getuserlist("vendor");
            getuserlist("employee");
          } else {
            getuserlist("client");
            getuserlist("hr");
          }

          alert(data.message);
        })
        .catch((error) => {
          console.log("Error with POST request:", error);
        });
    } else {
      alert("please enter all the fields");
    }
  };

  // change password
  const handlechangepassword = (value, formData) => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/changepassword.php`;
    const response = fetch(apiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (company) {
          if (value === "user") {
            setPopupvalue("");
            setEmployeeDashboard(false);
            setuserpassword({
              username: "",
              newpassword: "",
              confirmpassword: "",
            });
          } else if (value === "vendor") {
            setPopupvalue("");
            setVendorsDashboard(false);
            setvendorpassword({
              username: "",
              newpassword: "",
              confirmpassword: "",
            });
          }
        } else {
          if (value === "user") {
            setPopupvalue("");
            setEmployeeDashboard(false);
            setuserpassword({
              username: "",
              newpassword: "",
              confirmpassword: "",
            });
          } else if (value === "client") {
            setPopupvalue("");
            setVendorsDashboard(false);
            setvendorpassword({
              username: "",
              newpassword: "",
              confirmpassword: "",
            });
          }
        }
        alert(data.message);
      })
      .catch((error) => {
        console.log("Error with POST request:", error);
      });
  };
  const handleuserpassword = () => {
    if (
      userpassword.username &&
      userpassword.newpassword.trim() &&
      userpassword.confirmpassword === userpassword.newpassword
    ) {
      const formData = new FormData();
      formData.append("user_id", userpassword?.username);
      formData.append("password", userpassword?.newpassword);
      handlechangepassword("user", formData);
    } else {
      if (userpassword.confirmpassword != userpassword.newpassword) {
        seterror((prev) => ({
          ...prev,
          confirmpassword: "New password and confirm password is not same!",
        }));
      } else {
        alert("please enter both ");
      }
    }
  };
  const handlevendorpassword = () => {
    if (
      vendorpassword.username &&
      vendorpassword.newpassword.trim() &&
      vendorpassword.confirmpassword === vendorpassword.newpassword
    ) {
      const formData = new FormData();
      formData.append("user_id", vendorpassword?.username);
      formData.append("password", vendorpassword?.newpassword);
      handlechangepassword("vendor", formData);
    } else {
      if (vendorpassword.confirmpassword != vendorpassword.newpassword) {
        seterror((prev) => ({
          ...prev,
          confirmpassword: "New password and confirm password is not same!",
        }));
      } else {
        alert("please enter both ");
      }
    }
  };

  // update user
  const handleUserUpdate = () => {
    if (userupdate.hr && userupdate.username.trim()) {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/updateuserdetail.php`;
      const formData = new FormData();
      formData.append("user_id", userupdate?.hr);
      formData.append("username", userupdate?.username);
      const response = fetch(apiUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setPopupvalue("");
          // setIsMain3PopupOpen(false);
          setUserupdate({
            hr: "",
            username: "",
          });
          if (company) {
            getuserlist("employee");
          } else {
            getuserlist("hr");
          }

          setEmployeeDashboard(false);
          alert(data.message);
        })
        .catch((error) => {
          console.log("Error with POST request:", error);
        });
    } else {
      alert("please enter both username and hr");
    }
  };

  const handlevendorUpdate = () => {
    if (vendorupdate.vendor && vendorupdate.username.trim()) {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/updateuserdetail.php`;
      const formData = new FormData();
      formData.append("user_id", vendorupdate?.vendor);
      formData.append("username", vendorupdate?.username);
      const response = fetch(apiUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setPopupvalue("");
          // setIsMain3PopupOpen(false)
          setvendorupdate({
            vendor: "",
            username: "",
          });
          setVendorsDashboard(false);
          if (company) {
            getuserlist("vendor");
          } else {
            getuserlist("client");
          }
          alert(data.message);
        })
        .catch((error) => {
          console.log("Error with POST request:", error);
        });
    } else {
      alert("please enter both username and hr");
    }
  };

  const handleactive = () => {
    if (active?.user || active?.vendor) {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/useractinact.php`;
      const formData = new FormData();

      // Properly assigning the ID
      const id = active.user || active.vendor;
      formData.append("user_id", id); // Fixed issue here

      fetch(apiUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json()) // Simplified the response handling
        .then((data) => {
          setPopupvalue("");
          setactive({
            user: "",
            vendor: "",
          });
          setinactive({
            user: "",
            vendor: "",
          });
          if (company) {
            getinactivelist("employee");
            getuserlist("employee");
            getinactivelist("vendor");
            getuserlist("vendor");
          } else {
            getinactivelist("hr");
            getuserlist("hr");
            getinactivelist("client");
            getuserlist("client");
          }
          setVendorsDashboard(false);
          setEmployeeDashboard(false);
          alert(data.message);
        })
        .catch((error) => {
          console.log("Error with POST request:", error);
        });
    } else {
      alert("Please Select The ID");
    }
  };

  const handleinactive = () => {
    if (inactive?.user || inactive?.vendor) {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/useractinact.php`;
      const formData = new FormData();
      const id = inactive.user || inactive.vendor;
      formData.append("user_id", id);
      const response = fetch(apiUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setPopupvalue("");
          // setIsMain3PopupOpen(false)
          setactive({
            user: "",
            vendor: "",
          });
          setinactive({
            user: "",
            vendor: "",
          });
          if (company) {
            getinactivelist("employee");
            getuserlist("employee");
            getinactivelist("vendor");
            getuserlist("vendor");
          } else {
            getinactivelist("hr");
            getuserlist("hr");
            getinactivelist("client");
            getuserlist("client");
          }
          setVendorsDashboard(false);
          setEmployeeDashboard(false);
          alert(data.message);
        })
        .catch((error) => {
          console.log("Error with POST request:", error);
        });
    } else {
      alert("Please Select The ID");
    }
  };

  const getsubs = async () => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getsubs.php`;
    const fd = new FormData();
    fd.append("user_id", userDetails.userid);

    try {
      const res = await fetch(apiUrl, { method: "POST", body: fd });
      const json = await res.json();
      setsubs(json);
    } catch (err) {
      console.error("getSubs error:", err);
    }
  };

  // const COMPANY_ROLES = ["cadmin", "manager", "employee", "vendor"];
  // const SERVICE_ROLES = ["sadmin", "client", "HR", "HRM"];

  // /** true if current user belongs to the “company” bucket */
  // const isCompanyRole = COMPANY_ROLES.includes(userDetails?.role);
  // /** true if current user belongs to the “services” bucket */
  // const isServiceRole = SERVICE_ROLES.includes(userDetails?.role);

  const getuserlist = async (role) => {
    if (!subs?.subscriber_id || !subs?.pack) return;

    const base = company ? "vendors" : "clients";
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/${base}/getusers.php`;

    const fd = new FormData();
    fd.append("role", role);
    fd.append("subid", subs.subscriber_id);
    fd.append("pack", subs.pack);

    try {
      const res = await fetch(apiUrl, { method: "POST", body: fd });
      const json = await res.json();

      if (["employee", "hr"].includes(role)) {
        sethruser(json.data ?? []);
      } else if (["vendor", "client"].includes(role)) {
        setvendor(json.data ?? []);
      }
    } catch (err) {
      console.error(`getUserList (${role}) error:`, err);
    }
  };

  useEffect(() => {
    getsubs();
  }, []);

  useEffect(() => {
    if (!subs) return;
    if (company) {
      getuserlist("employee");
      getuserlist("vendor");
    }
    getuserlist("hr");
    getuserlist("client");
  }, [subs]);

  const getinactivelist = async (role) => {
    if (!subs?.subscriber_id || !subs?.pack) return;
    const base = company ? "vendors" : "clients";
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/${base}/getusersinactive.php`;
    const fd = new FormData();
    fd.append("role", role);
    fd.append("subid", subs.subscriber_id);
    fd.append("pack", subs.pack);

    try {
      const res = await fetch(apiUrl, { method: "POST", body: fd });
      const json = await res.json();
      console.log(json);

      if (["employee", "hr"].includes(role)) {
        setinactiveuser(json.data ?? []);
      } else if (["vendor", "client"].includes(role)) {
        setinactivevendor(json.data ?? []);
      }
    } catch (err) {
      console.error(`getInactiveList (${role}) error:`, err);
    }
  };

  useEffect(() => {
    if (!subs) return;
    if (company) {
      getinactivelist("employee");
      getinactivelist("vendor");
    } else {
      getinactivelist("hr");
      getinactivelist("client");
    }
  }, [subs]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
        // setaddactpopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const role = userDetails?.role ?? "";
  const remaining = Number(subs?.rd) || 0;

  const mandatory = role === "cadmin" && remaining <= 0;
  // const reminder = role === "cadmin" && remaining > 0 && remaining <= 5;

  // const [showTerms, setShowTerms] = useState(mandatory || reminder);

  // useEffect(() => {
  //   if (!subs) return;

  //   if (mandatory || reminder) {
  //     setShowTerms(true);
  //   } else {
  //     setShowTerms(false);
  //   }
  // }, [mandatory, reminder,subs]);

  // const [showTerms, setShowTerms] = useState(false);
  // const [dismissed, setDismissed] = useState(false); // NEW ❶

  // const dataReady = !!userDetails && !!subs && subs.rd != null;

  // useEffect(() => {
  //   if (!dataReady || dismissed) return; // ❷ skip when user pressed OK

  //   const role = userDetails.role;
  //   const remaining = Number(subs.rd);

  //   const mandatory = role === "cadmin" && remaining <= 0;
  //   const reminder = role === "cadmin" && remaining > 0 && remaining <= 5;

  //   setShowTerms(mandatory || reminder);
  // }, [dataReady, userDetails, subs, dismissed]);

  /* ---------- 1.  state ---------------------------------------------------- */
  const [dismissed, setDismissed] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  /* ---------- 2.  build a unique storage key once user data is ready ------ */
  const userKey =
    userDetails && userDetails.id
      ? `termsDismissed_${userDetails.id}`
      : null;

  /* ---------- 3.  AFTER login data arrives, pull dismissal flag ----------- */
  useEffect(() => {
    if (!userKey) return;                          // still loading user data
    const stored = sessionStorage.getItem(userKey) === "true";
    setDismissed(stored);                          // set once per refresh
  }, [userKey]);

  /* ---------- 4.  decide whether to show the modal ------------------------ */
  const dataReady = !!userDetails && !!subs && subs.rd != null;

  useEffect(() => {
    if (!dataReady || dismissed) return;           // keep hidden if dismissed

    const role      = userDetails.role;
    const remaining = Number(subs.rd);

    const mandatory = role === "cadmin" && remaining <= 0;
    const reminder  = role === "cadmin" && remaining > 0 && remaining <= 5;

    setShowTerms(mandatory || reminder);
  }, [dataReady, dismissed, userDetails, subs]);

  /* ---------- 5.  handle OK click for the reminder ------------------------ */
  const handleOk = () => {
    setShowTerms(false);
    setDismissed(true);
    if (userKey) sessionStorage.setItem(userKey, "true");
  };



  const company =
    userDetails?.role === "cadmin" ||
    userDetails?.role === "manager" ||
    userDetails?.role === "employee" ||
    userDetails?.role === "vendor";
  const services =
    userDetails?.role === "sadmin" ||
    userDetails?.role === "client" ||
    userDetails?.role === "HR" ||
    userDetails?.role === "HRM";

  return (
    <div>
      <h2 className="head">
        {userDetails?.role === "cadmin" || userDetails?.role === "sadmin"
          ? "ADMIN PORTAL"
          : userDetails?.role === "manager"
          ? "MANAGER PORTAL"
          : userDetails?.role === "employee"
          ? "EMPLOYEE PORTAL"
          : userDetails?.role === "vendor"
          ? "VENDOR PORTAL"
          : userDetails?.role === "HRM"
          ? "HR MANAGER PORTAL"
          : userDetails?.role === "HR"
          ? "HR PORTAL"
          : userDetails?.role === "client"
          ? "CLIENT PORTAL"
          : null}
      </h2>

      {showTerms && (
        <div className="terms-modal">
          <div className="terms-content">
            {mandatory ? (
              <>
                <div>
                  <div className="alert-header">
                    <TbAlertTriangleFilled className="alert-icon red" />
                    <h3>ALERT</h3>
                  </div>
                </div>
                <p style={{ padding: "25px" }}>
                  Your access has been suspended due to an expired plan. Renew
                  immediately to continue using the Website.
                </p>
              </>
            ) : (
              <>
                <div>
                  <div className="alert-header">
                    <PiNotePencilFill className="alert-icon yellow" />
                    <h3>REMINDER</h3>
                  </div>
                </div>
                <p style={{ paddingTop: "25px" }}>
                  Your pack is expired in {subs?.rd}{" "}
                  {subs?.rd === 1 ? "day" : "days"}. Please recharge soon to
                  avoid interruption.
                </p>
                <button
                  className="close-btn"
                  onClick={handleOk}
                >
                  OK
                </button>
              </>
            )}
          </div>
        </div>
      )}

      <div className="admin-container1">
        {/* #HR  */}
        {userDetails.role === "cadmin" ||
        hruser.user_id === "manager" ||
        userDetails.role === "sadmin" ||
        hruser.user_id === "hrm" ? (
          <div className="table-container">
            <table className="fixed-header-table">
              <thead>
                <tr>
                  <td colSpan={2} className="reg">
                    {company ? <h3>Employees Login</h3> : <h3>HR Login</h3>}
                  </td>
                </tr>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                </tr>
              </thead>
              <tbody>
                {hruser?.length > 0 ? (
                  hruser.map((row) => (
                    <tr key={row.user_id}>
                      <td>{row.user_id}</td>
                      <td>{row.username}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" style={{ textAlign: "center" }}>
                      There are no users.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ) : null}

        {/* #Form  */}
        <div>
          <form className="admin-form" onSubmit={handleSubmit}>
            <div className="admin-container">
              {/* vendor list*/}
              {userDetails.role !== "vendor" &&
              userDetails.role !== "client" ? (
                <div className="form-group">
                  {company ? (
                    <label htmlFor="vendor">Vendors</label>
                  ) : (
                    <label htmlFor="vendor">Clients</label>
                  )}
                  <select
                    id="vendor"
                    className="form-control"
                    value={listingValues?.vendor}
                    onChange={(e) => {
                      const selectedvendor = vendor.find(
                        (row) => row.username === e.target.value
                      );
                      setListingValues((prevUser) => ({
                        ...prevUser,
                        vendor_id: selectedvendor?.user_id,
                        vendor: selectedvendor?.username,
                      }));
                    }}
                    required
                  >
                    {company ? (
                      <option value={""} disabled>
                        Select Vendor
                      </option>
                    ) : (
                      <option value={""} disabled>
                        Select Client
                      </option>
                    )}
                    {/* inside your <select> … */}
                    {vendor?.length > 0 ? (
                      vendor.map(({ id, username }) => (
                        <option key={id ?? username} value={username}>
                          {username}
                        </option>
                      ))
                    ) : (
                      <>
                        {company ? (
                          <option value="" disabled>
                            No vendors
                          </option>
                        ) : (
                          <option value="" disabled>
                            No clients
                          </option>
                        )}
                      </>
                    )}
                  </select>
                </div>
              ) : null}

              {/* Year */}
              <div className="form-group">
                <label htmlFor="year">Year</label>
                <select
                  id="year"
                  className="form-control"
                  value={listingValues?.year}
                  onChange={(e) =>
                    setListingValues((prevUser) => ({
                      ...prevUser,
                      year: e.target.value,
                    }))
                  }
                  required
                >
                  <option value="" disabled>
                    Year
                  </option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>

              {/* Month */}
              <div className="form-group">
                <label htmlFor="month">Month</label>
                <select
                  id="month"
                  className="form-control"
                  value={listingValues?.month}
                  onChange={(e) =>
                    setListingValues((prevUser) => ({
                      ...prevUser,
                      month: e.target.value,
                    }))
                  }
                  required
                >
                  <option value="" disabled>
                    Month
                  </option>
                  {months.map((month, index) => (
                    <option key={index} value={month}>
                      {month}
                    </option>
                  ))}
                </select>
              </div>

              {services && (
                <>
                  {/* Division */}
                  <div className="form-group">
                    <label htmlFor="division">Division</label>
                    <select
                      id="division"
                      className="form-control"
                      value={listingValues?.division}
                      onChange={(e) =>
                        setListingValues((prevUser) => ({
                          ...prevUser,
                          division: e.target.value,
                        }))
                      }
                      required
                    >
                      <option value="" disabled>
                        Division
                      </option>
                      <option value="No_Division">No Division</option>
                      <option value="Division-1">Division-1</option>
                      <option value="Division-2">Division-2</option>
                      <option value="Division-3">Division-3</option>
                      <option value="Division-4">Division-4</option>
                    </select>
                  </div>
                </>
              )}
            </div>
            <button type="submit" className="bttn">
              Submit
            </button>
          </form>
          <div>
            {issubmitted && (
              <div className="fo">
                <h3>Selected Data:</h3>

                <div className="form-data-display">
                  {userDetails.role != "vendor" &&
                    userDetails.role != "client" &&
                    (company ? (
                      <p>
                        <strong>Vendor:</strong> {listingValues.vendor}
                      </p>
                    ) : (
                      <p>
                        <strong>Client:</strong> {listingValues.vendor}
                      </p>
                    ))}
                  {userDetails.role !== "vendor" &&
                    userDetails.role !== "client" && (
                      <p>
                        <strong>State:</strong>{" "}
                        {
                          vendor.find(
                            (c) => c.username === listingValues.vendor
                          )?.state
                        }
                      </p>
                    )}
                  <p>
                    <strong>Year:</strong> {listingValues.year}
                  </p>
                  <p>
                    <strong>Month:</strong> {listingValues.month}
                  </p>
                  {services && (
                    <p>
                      <strong>Division:</strong> {listingValues.month}
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* #menu  */}
        {userDetails.role === "cadmin" || userDetails.role === "sadmin" ? (
          <div className="menu">
            <div className="menu-dropdown">
              <button
                className="menu-button"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                Menu
              </button>
              {isMenuOpen && (
                <div className="menu-box" ref={menuRef}>
                  <button
                    className="menu-item"
                    onClick={() => setVendorsDashboard(true)}
                  >
                    {company ? (
                      <>
                        <FaUserTie /> VENDOR DASHBOARD
                      </>
                    ) : (
                      <>
                        <FaUserTie /> CLIENT DASHBOARD
                      </>
                    )}
                  </button>
                  <button
                    className="menu-item"
                    onClick={() => setEmployeeDashboard(true)}
                  >
                    {company ? (
                      <>
                        <RiUser3Fill /> EMPLOYEE DASHBOARD
                      </>
                    ) : (
                      <>
                        <RiUser3Fill /> UESR DASHBOARD
                      </>
                    )}
                  </button>
                  <Link
                    to="/reports"
                    className="nounderline"
                    state={{ vendor, subs, company }}
                  >
                    <button className="menu-item">
                      <LuNotebookPen /> REPORTS
                    </button>
                  </Link>
                </div>
              )}
            </div>

            {/* vendor */}
            {VendorsDashboard && (
              <div
                className="popup-overlay"
                onClick={() => setVendorsDashboard(false)}
              >
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  {company ? (
                    <h2 className="HeaderNew">
                      <FaUserTie /> VENDOR DASHBOARD
                    </h2>
                  ) : (
                    <h2 className="HeaderNew">
                      <FaUserTie /> CLIENT DASHBOARD
                    </h2>
                  )}

                  <div className="full-logo">
                    <div className="icon-container">
                      <div className="newlog">
                        <FaUserPlus
                          onClick={() => setPopupvalue("Addvendor")}
                        />
                      </div>
                      <div className="label">CREATE NEW</div>
                    </div>
                    <div>
                      <div className="Vline"></div>
                    </div>
                    <div>
                      <div className="icon-container">
                        <div className="newlog">
                          <FaUserPen
                            onClick={() => setPopupvalue("vendorpassword")}
                          />
                        </div>
                        <div className="label">CHANGE PASSWORD</div>
                      </div>
                      <br />
                      <br />
                      <div className="icon-container">
                        <div className="newlog">
                          <FaUserCheck
                            onClick={() => setPopupvalue("vendorActive")}
                          />
                        </div>
                        {company ? (
                          <div className="label">ACTIVE VENDOR</div>
                        ) : (
                          <div className="label">ACTIVE CLIENT</div>
                        )}
                      </div>
                    </div>
                    <div>
                      <div className="icon-container">
                        <div className="newlog">
                          <FaUserGear
                            onClick={() => setPopupvalue("vendorupdate")}
                          />
                        </div>
                        {company ? (
                          <div className="label">UPDATE VENDOR</div>
                        ) : (
                          <div className="label">UPDATE CLIENT</div>
                        )}
                      </div>

                      <br />
                      <br />

                      <div className="icon-container">
                        <div className="newlog">
                          <FaUserXmark
                            onClick={() => setPopupvalue("vendorinactive")}
                          />
                        </div>
                        {company ? (
                          <div className="label">INACTIVE VENDOR</div>
                        ) : (
                          <div className="label">INACTIVE CLIENT</div>
                        )}
                      </div>
                    </div>
                  </div>
                  <br />
                  <div>
                    <button
                      className="close-btn"
                      onClick={() => setVendorsDashboard(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "Addvendor" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>
                  <div className="CC">
                    <div className="form_container">
                      <div style={{ display: "flex" }}>
                        <div>
                          {company ? (
                            <span className="cname">Vendor Name: </span>
                          ) : (
                            <span className="cname">Client Name: </span>
                          )}
                          <input
                            type="text"
                            value={vendordetails.vendorname}
                            placeholder="Enter vendor Name"
                            required
                            onChange={(e) =>
                              setvendordetails((prevUser) => ({
                                ...prevUser,
                                vendorname: e.target.value,
                              }))
                            }
                            className="Name"
                          />
                          {company ? (
                            <span className="cname">Vendor Code: </span>
                          ) : (
                            <span className="cname">Client Code: </span>
                          )}
                          <input
                            type="text"
                            value={vendordetails.vendorcode}
                            placeholder="Enter vendor Code"
                            required
                            onChange={(e) =>
                              setvendordetails((prevUser) => ({
                                ...prevUser,
                                vendorcode: e.target.value,
                              }))
                            }
                            className="Name"
                          />
                          <span className="cname">Username: </span>
                          <input
                            type="text"
                            value={vendordetails.username}
                            placeholder="Enter Username"
                            required
                            onChange={(e) =>
                              setvendordetails((prevUser) => ({
                                ...prevUser,
                                username: e.target.value,
                              }))
                            }
                            className="Name"
                          />
                          <span className="cname">Email: </span>
                          <input
                            type="email"
                            value={vendordetails.email}
                            placeholder="Enter a email"
                            required
                            onChange={(e) =>
                              setvendordetails((prevUser) => ({
                                ...prevUser,
                                email: e.target.value,
                              }))
                            }
                            className="Name"
                          />
                        </div>
                        <div>
                          <span className="cname">Password: </span>
                          <input
                            type="password"
                            value={vendordetails.password}
                            placeholder="Enter Password"
                            required
                            onChange={(e) =>
                              setvendordetails((prevUser) => ({
                                ...prevUser,
                                password: e.target.value,
                              }))
                            }
                            className="Name"
                          />
                          <span className="cname">Confirm Password: </span>
                          <input
                            type="password"
                            value={vendordetails.confirmpassword}
                            placeholder="Enter Password"
                            required
                            onChange={(e) =>
                              setvendordetails((prevUser) => ({
                                ...prevUser,
                                confirmpassword: e.target.value,
                              }))
                            }
                            className="Name"
                          />
                          <span className="cname">Phone Number: </span>
                          <input
                            type="tel"
                            pattern="{0-9}[10]"
                            value={vendordetails.ph}
                            placeholder="Enter a Phone Number"
                            required
                            onChange={(e) =>
                              setvendordetails((prevUser) => ({
                                ...prevUser,
                                ph: e.target.value,
                              }))
                            }
                            className="Name"
                          />
                          <span className="cname">State: </span>
                          <select
                            required
                            className="ds1"
                            onChange={(e) =>
                              setvendordetails((prev) => ({
                                ...prev,
                                state: e.target.value,
                              }))
                            }
                            value={vendordetails.state}
                          >
                            {/* 
                        <option value="" default className='do2'>
                          Select State
                        </option> */}
                            {/* <option value="tamil_nadu">Tamil Nadu</option>
                        <option value="maharashtra">Maharashtra</option>
                        <option value="odisha">Odisha</option>
                        <option value="karnataka">Karnataka</option> */}

                            <option value="" disabled>
                              Select State
                            </option>
                            <option value="andhra_pradesh">
                              Andhra Pradesh
                            </option>
                            <option value="arunachal_pradesh">
                              Arunachal Pradesh
                            </option>
                            <option value="assam">Assam</option>
                            <option value="bihar">Bihar</option>
                            <option value="chhattisgarh">Chhattisgarh</option>
                            <option value="delhi">Delhi</option>
                            <option value="goa">Goa</option>
                            <option value="gujarat">Gujarat</option>
                            <option value="haryana">Haryana</option>
                            <option value="himachal_pradesh">
                              Himachal Pradesh
                            </option>
                            <option value="jharkhand">Jharkhand</option>
                            <option value="karnataka">Karnataka</option>
                            <option value="kerala">Kerala</option>
                            <option value="madhya_pradesh">
                              Madhya Pradesh
                            </option>
                            <option value="maharashtra">Maharashtra</option>
                            <option value="manipur">Manipur</option>
                            <option value="meghalaya">Meghalaya</option>
                            <option value="mizoram">Mizoram</option>
                            <option value="nagaland">Nagaland</option>
                            <option value="odisha">Odisha</option>
                            <option value="punjab">Punjab</option>
                            <option value="rajasthan">Rajasthan</option>
                            <option value="sikkim">Sikkim</option>
                            <option value="tamil_nadu">Tamil Nadu</option>
                            <option value="telangana">Telangana</option>
                            <option value="tripura">Tripura</option>
                            <option value="uttar_pradesh">Uttar Pradesh</option>
                            <option value="uttarakhand">Uttarakhand</option>
                            <option value="west_bengal">West Bengal</option>
                          </select>
                        </div>
                      </div>

                      <button
                        onClick={() =>
                          handleCreate(company ? "vendor" : "client")
                        }
                        className="create"
                      >
                        Create
                      </button>
                    </div>
                  </div>
                  {/* <button className="close-btn" onClick={() => setIsNestedCPopupOpen(false)}>Close</button> */}
                </div>
              </div>
            )}
            {popupvalue === "vendorpassword" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>
                  <div className="CC">
                    <div className="form_container">
                      {company ? (
                        <span className="cname">Vendor Name: </span>
                      ) : (
                        <span className="cname">Client Name: </span>
                      )}
                      <select
                        className="ds1"
                        value={vendorpassword.username}
                        onChange={(e) =>
                          setvendorpassword((prevUser) => ({
                            ...prevUser,
                            username: e.target.value,
                          }))
                        }
                      >
                        {company ? (
                          <option value="" disabled selected>
                            Select Vendor
                          </option>
                        ) : (
                          <option value="" disabled selected>
                            Select Client
                          </option>
                        )}

                        {/* inside your <select> … */}
                        {vendor?.length > 0 ? (
                          vendor.map(({ id, username, user_id }) => (
                            <option key={id ?? username} value={user_id}>
                              {username}
                            </option>
                          ))
                        ) : (
                          <>
                            {company ? (
                              <option value="" disabled selected>
                                No Vendors
                              </option>
                            ) : (
                              <option value="" disabled selected>
                                No Clients
                              </option>
                            )}
                          </>
                        )}
                      </select>

                      <span className="cname">New Password: </span>
                      <input
                        type="password"
                        value={vendorpassword.newpassword}
                        placeholder="New password"
                        required
                        onChange={(e) =>
                          setvendorpassword((prevUser) => ({
                            ...prevUser,
                            newpassword: e.target.value,
                          }))
                        }
                        className="Name"
                      />
                      <span className="cname">Confirm Password: </span>
                      <input
                        type="password"
                        value={vendorpassword.confirmpassword}
                        placeholder="Confirm Password"
                        required
                        onChange={(e) => {
                          setvendorpassword((prev) => ({
                            ...prev,
                            confirmpassword: e.target.value,
                          }));
                          if (vendorpassword.newpassword === e.target.value) {
                            seterror((prev) => ({
                              ...prev,
                              confirmpassword: "",
                            }));
                          }
                        }}
                        className="Name"
                      />
                      {error.confirmpassword ? (
                        <p>{error.confirmpassword} </p>
                      ) : null}

                      <button
                        onClick={() => handlevendorpassword()}
                        className="create"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "vendorupdate" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>
                  <div className="CC">
                    <div className="form_container">
                      {company ? (
                        <span className="cname">Vendor`s Name: </span>
                      ) : (
                        <span className="cname">Client`s Name: </span>
                      )}
                      <select
                        value={vendorupdate?.vendor}
                        className="ds1"
                        onChange={(e) =>
                          setvendorupdate((prev) => ({
                            ...prev,
                            vendor: e.target.value,
                          }))
                        }
                      >
                        {company ? (
                          <option value="" disabled selected>
                            Choose Vendor
                          </option>
                        ) : (
                          <option value="" disabled selected>
                            Choose Client
                          </option>
                        )}

                        {/* inside your <select> … */}
                        {vendor?.length > 0 ? (
                          vendor.map(({ id, username, user_id }) => (
                            <option key={id ?? username} value={user_id}>
                              {username}
                            </option>
                          ))
                        ) : (
                          <>
                            {company ? (
                              <option value="" disabled>
                                No vendors
                              </option>
                            ) : (
                              <option value="" disabled selected>
                                No Client
                              </option>
                            )}
                          </>
                        )}
                      </select>

                      <span className="cname">User Name: </span>
                      <input
                        type="text"
                        value={vendorupdate?.username}
                        placeholder="Enter Name"
                        required
                        onChange={(e) =>
                          setvendorupdate((prev) => ({
                            ...prev,
                            username: e.target.value,
                          }))
                        }
                        className="Name"
                      />

                      <button onClick={handlevendorUpdate} className="create">
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "vendorActive" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>
                  <div className="CC">
                    <div className="form_container">
                      {company ? (
                        <span className="cname">Vendor`s Name: </span>
                      ) : (
                        <span className="cname">Client`s Name: </span>
                      )}

                      <select
                        value={active?.vendor}
                        className="ds1"
                        onChange={(e) =>
                          setactive((prev) => ({
                            ...prev,
                            vendor: e.target.value,
                          }))
                        }
                      >
                        {company ? (
                          <option value="" disabled selected>
                            Choose Vendor
                          </option>
                        ) : (
                          <option value="" disabled selected>
                            Choose Client
                          </option>
                        )}
                        {/* inside your <select> … */}
                        {vendor?.length > 0 ? (
                          vendor.map(({ id, username, user_id }) => (
                            <option key={id ?? username} value={user_id}>
                              {username}
                            </option>
                          ))
                        ) : (
                          <>
                            {company ? (
                              <option value="" disabled>
                                No vendors
                              </option>
                            ) : (
                              <option value="" disabled selected>
                                No Client
                              </option>
                            )}
                          </>
                        )}
                      </select>

                      {/* <select value={userupdate?.hr} className='ds1' onChange={(e) => setUserupdate(prev => ({ ...prev, hr: e.target.value }))}>
                        <option value="" disabled selected>Choose HR</option>
                        {
                          hruser.map(row => {
                            return <option value={row?.id} >{row?.user_id}</option>
                          })
                        }
                      </select> */}

                      {/* <span className='cname'>User Name: </span>
                      <input
                        type="text"
                        value={userupdate?.username}
                        placeholder="Enter Name"
                        required
                        onChange={(e) => setUserupdate(prev => ({ ...prev, username: e.target.value }))}
                        className='Name'
                      /> */}

                      <button onClick={handleactive} className="create">
                        Inactive
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "vendorinactive" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>

                  <div className="CC">
                    <div className="form_container">
                      {company ? (
                        <span className="cname">Vendor`s Name: </span>
                      ) : (
                        <span className="cname">Client`s Name: </span>
                      )}
                      <select
                        value={inactive?.vendor}
                        className="ds1"
                        onChange={(e) =>
                          setinactive((prev) => ({
                            ...prev,
                            vendor: e.target.value,
                          }))
                        }
                      >
                        {company ? (
                          <option value="" disabled selected>
                            Choose Vendor
                          </option>
                        ) : (
                          <option value="" disabled selected>
                            Choose Client
                          </option>
                        )}
                        {Array.isArray(inactivevendor) &&
                        inactivevendor.length > 0 ? (
                          inactivevendor.map((row) => (
                            <option key={row?.id} value={row?.user_id}>
                              {row?.username}
                            </option>
                          ))
                        ) : (
                          <>
                            {company ? (
                              <option value="" disabled>
                                No vendors
                              </option>
                            ) : (
                              <option value="" disabled selected>
                                No Client
                              </option>
                            )}
                          </>
                        )}
                      </select>
                      <button onClick={handleinactive} className="create">
                        Active
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* USER */}
            {EmployeeDashboard && (
              <div
                className="popup-overlay"
                onClick={() => setEmployeeDashboard(false)}
              >
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  {company ? (
                    <h2 className="HeaderNew">
                      <FaUserTie /> EMPLOYEE DASHBOARD
                    </h2>
                  ) : (
                    <h2 className="HeaderNew">
                      <FaUserTie /> USER DASHBOARD
                    </h2>
                  )}

                  <div className="full-logo">
                    <div className="icon-container">
                      <div className="newlog">
                        <FaUserPlus onClick={() => setPopupvalue("Adduser")} />
                        {/* <div className="vendorname">vendor</div> */}
                      </div>
                      <div className="label">CREATE NEW</div>
                    </div>

                    <div>
                      <div className="Vline"></div>
                    </div>
                    <div>
                      <div className="icon-container">
                        <div className="newlog">
                          <FaUserPen
                            onClick={() => setPopupvalue("userpassword")}
                          />
                        </div>

                        <div className="label">CHANGE PASSWORD</div>
                      </div>
                      <br />
                      <br />
                      <div className="icon-container">
                        <div className="newlog">
                          <FaUserCheck
                            onClick={() => setPopupvalue("userActive")}
                          />
                        </div>

                        <div className="label">ACTIVE USER</div>
                      </div>
                    </div>

                    <div>
                      <div className="icon-container">
                        <div className="newlog">
                          <FaUserGear
                            onClick={() => setPopupvalue("userupdate")}
                          />
                        </div>

                        <div className="label">UPDATE USER</div>
                      </div>

                      <br />
                      <br />

                      <div className="icon-container">
                        <div className="newlog">
                          <FaUserXmark
                            onClick={() => setPopupvalue("userinactive")}
                          />
                        </div>
                        <div className="label">INACTIVE USER</div>
                      </div>
                    </div>
                  </div>

                  <br />
                  <div>
                    <button
                      className="close-btn"
                      onClick={() => setEmployeeDashboard(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "Adduser" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>
                  <div className="CC">
                    <div className="form_container">
                      <div style={{ display: "flex" }}>
                        <div>
                          <span className="cname">Name: </span>
                          <input
                            type="text"
                            value={vendordetails.vendorname}
                            placeholder="Enter Name"
                            required
                            onChange={(e) =>
                              setvendordetails((prevUser) => ({
                                ...prevUser,
                                vendorname: e.target.value,
                              }))
                            }
                            className="Name"
                          />
                          <span className="cname">User Name: </span>
                          <input
                            type="text"
                            value={vendordetails.username}
                            placeholder="Enter username"
                            required
                            onChange={(e) =>
                              setvendordetails((prevUser) => ({
                                ...prevUser,
                                username: e.target.value,
                              }))
                            }
                            className="Name"
                          />
                          <span className="cname">Email: </span>
                          <input
                            type="email"
                            value={vendordetails.email}
                            placeholder="Enter a email"
                            required
                            onChange={(e) =>
                              setvendordetails((prevUser) => ({
                                ...prevUser,
                                email: e.target.value,
                              }))
                            }
                            className="Name"
                          />
                        </div>
                        <div>
                          <span className="cname">Password: </span>
                          <input
                            type="password"
                            value={vendordetails.password}
                            placeholder="Enter Password"
                            required
                            onChange={(e) =>
                              setvendordetails((prevUser) => ({
                                ...prevUser,
                                password: e.target.value,
                              }))
                            }
                            className="Name"
                          />
                          <span className="cname">Confirm Password: </span>
                          <input
                            type="password"
                            value={vendordetails.confirmpassword}
                            placeholder="Enter Password"
                            required
                            onChange={(e) =>
                              setvendordetails((prevUser) => ({
                                ...prevUser,
                                confirmpassword: e.target.value,
                              }))
                            }
                            className="Name"
                          />

                          <span className="cname">Phone Number: </span>
                          <input
                            type="tel"
                            pattern="{0-9}[10]"
                            value={vendordetails.ph}
                            placeholder="Enter a Phone Number"
                            required
                            onChange={(e) =>
                              setvendordetails((prevUser) => ({
                                ...prevUser,
                                ph: e.target.value,
                              }))
                            }
                            className="Name"
                          />
                        </div>
                      </div>

                      <button
                        onClick={() =>
                          handleCreate(company ? "employee" : "hr")
                        }
                        className="create"
                      >
                        Create
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "userpassword" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>
                  <div className="CC">
                    <div className="form_container">
                      <span className="cname">User Name: </span>

                      <select
                        value={userpassword?.username}
                        className="ds1"
                        onChange={(e) =>
                          setuserpassword((prev) => ({
                            ...prev,
                            username: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled selected>
                          choose HR
                        </option>
                        {/* inside your <select> … */}
                        {hruser?.length > 0 ? (
                          hruser.map(({ id, user_id }) => (
                            <option key={id} value={user_id}>
                              {user_id}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No users
                          </option>
                        )}
                      </select>

                      <span className="cname">New Password: </span>
                      <input
                        type="password"
                        value={userpassword.newpassword}
                        placeholder="New password"
                        required
                        onChange={(e) =>
                          setuserpassword((prev) => ({
                            ...prev,
                            newpassword: e.target.value,
                          }))
                        }
                        className="Name"
                      />
                      <span className="cname">Confirm Password: </span>
                      <input
                        type="password"
                        value={userpassword.confirmpassword}
                        placeholder="Confirm Password"
                        required
                        onChange={(e) => {
                          setuserpassword((prev) => ({
                            ...prev,
                            confirmpassword: e.target.value,
                          }));
                          if (userpassword.newpassword === e.target.value) {
                            seterror((prev) => ({
                              ...prev,
                              confirmpassword: "",
                            }));
                          }
                        }}
                        className="Name"
                      />

                      {error.confirmpassword ? (
                        <p>{error.confirmpassword} </p>
                      ) : null}
                      <button
                        onClick={() => handleuserpassword()}
                        className="create"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "userupdate" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>
                  <div className="CC">
                    <div className="form_container">
                      <span className="cname">HR ID: </span>

                      <select
                        value={userupdate?.hr}
                        className="ds1"
                        onChange={(e) =>
                          setUserupdate((prev) => ({
                            ...prev,
                            hr: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled selected>
                          Choose HR
                        </option>
                        {/* inside your <select> … */}
                        {hruser?.length > 0 ? (
                          hruser.map(({ id, user_id }) => (
                            <option key={id} value={user_id}>
                              {user_id}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No users
                          </option>
                        )}
                      </select>

                      <span className="cname">User Name: </span>
                      <input
                        type="text"
                        value={userupdate?.username}
                        placeholder="Enter Name"
                        required
                        onChange={(e) =>
                          setUserupdate((prev) => ({
                            ...prev,
                            username: e.target.value,
                          }))
                        }
                        className="Name"
                      />

                      <button onClick={handleUserUpdate} className="create">
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "userActive" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>
                  <div className="CC">
                    <div className="form_container">
                      <span className="cname">HR ID: </span>

                      <select
                        value={active?.user}
                        className="ds1"
                        onChange={(e) =>
                          setactive((prev) => ({
                            ...prev,
                            user: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled>
                          Choose HR
                        </option>
                        {/* inside your <select> … */}
                        {hruser?.length > 0 ? (
                          hruser.map(({ id, user_id }) => (
                            <option key={id} value={user_id}>
                              {user_id}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No users
                          </option>
                        )}
                      </select>

                      {/* <select value={userupdate?.hr} className='ds1' onChange={(e) => setUserupdate(prev => ({ ...prev, hr: e.target.value }))}>
                        <option value="" disabled selected>Choose HR</option>
                        {
                          hruser.map(row => {
                            return <option value={row?.id} >{row?.user_id}</option>
                          })
                        }
                      </select> */}

                      {/* <span className='cname'>User Name: </span>
                      <input
                        type="text"
                        value={userupdate?.username}
                        placeholder="Enter Name"
                        required
                        onChange={(e) => setUserupdate(prev => ({ ...prev, username: e.target.value }))}
                        className='Name'
                      /> */}

                      <button onClick={handleactive} className="create">
                        Inactive
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "userinactive" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>

                  <div className="CC">
                    <div className="form_container">
                      <span className="cname">HR ID: </span>
                      <select
                        value={inactive?.user}
                        className="ds1"
                        onChange={(e) =>
                          setinactive((prev) => ({
                            ...prev,
                            user: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled>
                          Choose HR
                        </option>
                        {Array.isArray(inactiveuser) &&
                        inactiveuser.length > 0 ? (
                          inactiveuser.map((row) => (
                            <option key={row?.id} value={row?.user_id}>
                              {row?.user_id}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No HR available
                          </option>
                        )}
                      </select>
                      <button onClick={handleinactive} className="create">
                        Active
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : null}
      </div>

      {showAdditionalComponent && (
        <div className="additional-component">
          <Heading
            selectedState={
              vendor.find((c) => c.username === listingValues.vendor)?.state
            }
            selectedTable={selectedTable}
            setSelectedTable={setSelectedTable}
            username={userDetails.username}
            selectedid={listingValues?.vendor_id}
            selectedname={listingValues.vendor}
            selectedyear={listingValues.year}
            selectedmonth={listingValues.month}
            selecteddivision={listingValues.division}
            company={company}
          />
        </div>
      )}
    </div>
  );
}

export default Admin;
